module.exports = __webpack_public_path__ + "img/mandala.a69bf310.png";